import { API_BASE_URL } from '../../../config/api';
import {
  clearStoredAuthIfUnauthorized,
  extractApiErrorMessage,
  parseResponseJson,
  readStoredAuth,
  SIGN_IN_REQUIRED_MESSAGE,
} from '../profileFormUtils';

/**
 * @returns {(path: string, opts?: { method?: string, body?: object }) => Promise<unknown>}
 */
export function createAddressApiClient() {
  return async (path, { method = 'GET', body } = {}) => {
    const token = readStoredAuth().token;
    if (!token) throw new Error(SIGN_IN_REQUIRED_MESSAGE);
    const res = await fetch(`${API_BASE_URL}${path}`, {
      method,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        ...(body ? { 'Content-Type': 'application/json' } : null),
      },
      body: body ? JSON.stringify(body) : undefined,
    });
    const data = await parseResponseJson(res);
    if (!res.ok) {
      clearStoredAuthIfUnauthorized(res.status);
      const fromBody = extractApiErrorMessage(data);
      throw new Error(
        fromBody || (res.status === 401 ? SIGN_IN_REQUIRED_MESSAGE : 'Address request failed.'),
      );
    }
    return data;
  };
}

/**
 * @param {{
 *   id?: number | null,
 *   name: string,
 *   type?: number,
 *   address: string,
 *   city: string,
 *   state: string,
 *   country?: string,
 *   postalCode: string,
 *   isPrimary?: boolean,
 *   latitude: number | string,
 *   longitude: number | string,
 * }} form
 * @param {{ includeId?: boolean }} [options]
 */
export function addressFormToApiPayload(form, options = {}) {
  const payload = {
    name: String(form.name || '').trim(),
    type: Number.isFinite(Number(form.type)) ? Number(form.type) : 0,
    address: String(form.address || '').trim(),
    city: String(form.city || '').trim(),
    state: String(form.state || '').trim(),
    country: String(form.country || '').trim() || 'India',
    postalCode: String(form.postalCode || '').trim(),
    isPrimary: Boolean(form.isPrimary),
    latitude: Number(form.latitude),
    longitude: Number(form.longitude),
  };
  if (options.includeId && form.id != null) payload.id = Number(form.id);
  return payload;
}
